import { useFormikContext } from "formik";
import React, { forwardRef } from "react";
import { Button, ButtonProps } from "../Button";

export const FormikSubmitButton = forwardRef(({ loading, ...restProps }: ButtonProps, ref) => {
  const { isSubmitting } = useFormikContext();

  return <Button {...restProps} ref={ref} loading={loading || isSubmitting} />;
});
